import { render, staticRenderFns } from "./editor-mode-switcher.vue?vue&type=template&id=54be4a7a&"
import script from "./editor-mode-switcher.vue?vue&type=script&lang=js&"
export * from "./editor-mode-switcher.vue?vue&type=script&lang=js&"
import style0 from "./editor-mode-switcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports